import styled from 'styled-components';
import Button from 'bit/mobiauto.web-ui-components.components.button/Button';

export const ConfirmButton = styled(Button)`
  display: flex;
  background: #f44336 !important;
  color: #fff !important;
  text-transform: none !important;
`;
